<template>
  <div class="d-flex flex-row flex-nowrap align-center py-2" :key="teacher.id" @click="$emit('change', teacher)">
    <div>
      <router-link class="teacher-link" v-if="link" :to="'/teacher/' + teacher.id">
        <div class="teacher-name">{{ teacher.name }}</div>
      </router-link>
      <div style="white-space: nowrap" v-else>{{ teacher.name }}</div>
      <div class="grey--text" v-if="isCodeShown">{{ teacher.code }}</div>
    </div>
  </div>
</template>
<script>
import { get } from 'lodash'

export default {
  props: {
    teacher: Object,
    prepend: Object,
    append: Object,
    attendance: Object,
    link: Boolean,
    isCodeShown: Boolean
  },
  computed: {
    avatar() {
      return get(this.teacher, 'avatar.url', '/default-avatar.svg')
    }
  }
}
</script>

<style lang="scss" scoped>
.teacher-link {
  text-decoration: none !important;
}
</style>
